import React from 'react'
import {
  GoogleMap,
  InfoWindow,
  LoadScriptNext,
  Marker
} from '@react-google-maps/api'

import { CenterType, MemberCenter } from '../../types'
import { initialMemberCenterState } from '../../redux/slices/memberCenterSlice'
import { BlueMapIcon, PurpleMapIcon, RedMapIcon } from '../../assets'

export type GoogleMapProps = {
  memberCenters: MemberCenter[]
  onMapLoad?: () => void
}

export const CustomGoogleMap: React.FC<GoogleMapProps> = ({
  memberCenters,
  onMapLoad
}: GoogleMapProps) => {
  const mapStyles = {
    height: '60vh',
    width: '100%',
    margin: 'auto'
  }
  const [center, setCenter] = React.useState({
    lat: 39.05,
    lng: -97.75
  })
  const [selected, setSelected] = React.useState(initialMemberCenterState)
  const [zoom, setZoom] = React.useState(5)

  const onSelect = (center: MemberCenter) => {
    setZoom(8)
    setCenter({ lat: center.latitude, lng: center.longitude })
    setSelected(center)
  }

  const handleMapLoad = React.useCallback(() => {
    if (onMapLoad) {
      onMapLoad()
    }
  }, [onMapLoad])

  const handleScriptLoad = React.useCallback(() => {
    // Script has loaded, but map might not be ready yet
    // We'll let the map's onLoad handle the final loading state
  }, [])

  return (
    <LoadScriptNext
      googleMapsApiKey={
        import.meta.env.VITE_GOOGLE_MAP_KEY ||
        import.meta.env.REACT_APP_GOOGLE_MAP_KEY ||
        ''
      }
      onLoad={handleScriptLoad}
    >
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={zoom}
        center={center}
        mapContainerClassName="rounded-lg shadow-xl"
        onLoad={handleMapLoad}
      >
        {memberCenters.map((center) => {
          return (
            <Marker
              key={center.centerName}
              position={{ lat: center.latitude, lng: center.longitude }}
              onClick={() => onSelect(center)}
              icon={
                center.centerType === CenterType.Adult.toLowerCase()
                  ? RedMapIcon
                  : center.centerType === CenterType.Pediatric.toLowerCase()
                    ? BlueMapIcon
                    : PurpleMapIcon
              }
            />
          )
        })}
        {selected.latitude && (
          <InfoWindow
            position={{ lat: selected.latitude, lng: selected.longitude }}
            onCloseClick={() => setSelected(initialMemberCenterState)}
          >
            <a
              href={selected.websiteAddress ? selected.websiteAddress : ''}
              className="link-text"
            >
              {selected.centerName}
            </a>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScriptNext>
  )
}
